"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("./strategy/util");
var PayloadType;
(function (PayloadType) {
    PayloadType["STRING"] = "string";
})(PayloadType || (PayloadType = {}));
function getDefaultVariant() {
    return {
        name: 'disabled',
        enabled: false,
    };
}
exports.getDefaultVariant = getDefaultVariant;
var stickynessSelectors = ['userId', 'sessionId', 'remoteAddress'];
function getSeed(context) {
    var result;
    stickynessSelectors.some(function (key) {
        var value = context[key];
        if (typeof value === 'string' && value !== '') {
            result = value;
            return true;
        }
        return false;
    });
    return result || String(Math.round(Math.random() * 100000));
}
function overrideMatchesContext(context) {
    return function (o) { return o.values.some(function (value) { return value === context[o.contextName]; }); };
}
function findOverride(feature, context) {
    return feature.variants
        .filter(function (variant) { return variant.overrides; })
        .find(function (variant) { return variant.overrides.some(overrideMatchesContext(context)); });
}
function selectVariant(feature, context) {
    var totalWeight = feature.variants.reduce(function (acc, v) { return acc + v.weight; }, 0);
    if (totalWeight <= 0) {
        return null;
    }
    var variantOverride = findOverride(feature, context);
    if (variantOverride) {
        return variantOverride;
    }
    var target = util_1.normalizedValue(getSeed(context), feature.name, totalWeight);
    var counter = 0;
    var variant = feature.variants.find(function (variant) {
        if (variant.weight === 0) {
            return;
        }
        counter += variant.weight;
        if (counter < target) {
            return;
        }
        else {
            return variant;
        }
    });
    return variant || null;
}
exports.selectVariant = selectVariant;
//# sourceMappingURL=variant.js.map